import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "h-flex-dir-column h-flex-center" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "h-font-22 h-mt-20 h-mb-0" }
const _hoisted_4 = {
  key: 1,
  class: "h-mt-10 h-mb-20"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  class: "h-flex h-flex-center",
  style: {"height":"20%"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FwButton = _resolveComponent("FwButton")!
  const _component_FwPopup = _resolveComponent("FwPopup")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.popupBackground)
  }, [
    _createVNode(_component_FwPopup, {
      centered: true,
      isFixed: true,
      iconColor: "#BEC7D4",
      "max-width": "800px",
      width: "auto",
      title: "",
      allowBackgroundScrolling: true,
      showClosePopup: false,
      popupBackground: _ctx.backgroundColor,
      popupRadius: "20px",
      heightValue: "100%",
      onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit("close")))
    }, {
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          (_ctx.showImage)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                class: "h-ph-50",
                src: _ctx.requireImage("well-done.svg")
              }, null, 8, _hoisted_2))
            : _createCommentVNode("", true),
          _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.$t(_ctx.header)), 1),
          (_ctx.subMessage)
            ? (_openBlock(), _createElementBlock("p", _hoisted_4, [
                (_ctx.eventTitle)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, " \"" + _toDisplayString(_ctx.$t(_ctx.eventTitle)) + "\" ", 1))
                  : _createCommentVNode("", true),
                _createTextVNode(" " + _toDisplayString(_ctx.$t(_ctx.subMessage)), 1)
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_FwButton, {
            class: "h-mt-20",
            borderRadiusType: "small-border",
            onClick: _ctx.emitMethod
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t(_ctx.buttonText)), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      _: 1
    }, 8, ["popupBackground"])
  ], 2))
}